module.exports = __webpack_public_path__ + "img/6.181158c6.jpg";